import React ,{useState, useEffect, useRef} from "react"
import { Document, Page, pdfjs  } from 'react-pdf';
import CancelIcon from '@mui/icons-material/Cancel';
import Loading from "../Chatwidget/Loading";
import ZoomInIcon from '@mui/icons-material/ZoomIn';
import ZoomOutIcon from '@mui/icons-material/ZoomOut';
import CloseBar from "../../../assets/images/ttd/close-sidebar.png"
import DownloadIcon from '@mui/icons-material/Download';

function PdfSideView({pdfSideViwer, setSideViewer}){
    const [numPages, setNumPages] = useState("")
    const [scale, setScale] = useState(0.4);
    const containerRef = useRef(null);
    const onDocumentLoadSuccess = ({ numPages })=> {
        // setTimeout(()=>{
        //     scrollToBottom();
        // },2000)
        setNumPages(numPages);
        if (containerRef.current) {
            const containerWidth = containerRef.current.clientWidth;
            setScale(containerWidth / 767);
        }
    }
    const zoomIn = () => {
        setScale(prevScale => prevScale + 0.2);
    };
    
    const zoomOut = () => {
      setScale(prevScale => (prevScale > 0.4 ? prevScale - 0.2 : prevScale));
    };

    const checkFullBot = () => {
        const botType = process.env.REACT_APP_PROD === "true" ? window.bot_type : process.env.REACT_APP_TYPE
        if (botType === "Full" || botType === "TlkDocs") {
            return true
        } else {
            return false
        }
    }

    return(
        <div className={`pdf-sideview-wrapper ${pdfSideViwer.show ? "show" : ""}`} ref={containerRef}>
            <div className="pdf-wrap-header">
                <h6>Document Preview</h6>
                {
                    checkFullBot() ?
                        <div style={{ justifyContent: 'center',alignItems: "center", marginBottom: '10px' }}>
                            <a href={pdfSideViwer.url} target="_blank" download>
                                <DownloadIcon className="zoom-btn" />
                            </a>
                            {
                                pdfSideViwer.url?.split('.').pop()?.toLowerCase() === "pdf" && <>
                                    <ZoomInIcon className="c-pointer zoom-btn" style={{marginLeft: "5px"}} onClick={zoomIn} />
                                    <ZoomOutIcon className="c-pointer zoom-btn" onClick={zoomOut} />
                                </>
                            }
                        </div>
                    :
                        <>  
                            <CancelIcon className="close-pdf-icon" onClick={()=> setSideViewer({show: false, url: ""})} />
                        </>
                }
            </div>
            <div className="pdf-wrap-body">
                {checkFullBot() && <svg width="38" height="88" className="closebar-toggler" onClick={()=> setSideViewer({show: false, url: ""})} viewBox="0 0 38 88" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <g filter="url(#filter0_d_653_3422)">
                                    <path d="M25 7H5V77H25L35 65.3333V18.6667L25 7Z" fill="var(--btn-bg)" />
                                </g>
                                <path d="M25.8332 42C25.8339 42.3915 25.7516 42.7794 25.591 43.1412C25.4304 43.503 25.1947 43.8316 24.8973 44.1082L16.4285 52L14.1665 49.8918L22.6338 42L14.1665 34.1082L16.4285 32L24.8957 39.8918C25.1933 40.1682 25.4294 40.4968 25.5903 40.8587C25.7511 41.2205 25.8337 41.6084 25.8332 42Z" fill="white" />
                                <g filter="url(#filter1_d_653_3422)">
                                    <path d="M10 2L5 7H10V2Z" fill="var(--btn-bg)" />
                                </g>
                                <g filter="url(#filter2_d_653_3422)">
                                    <path d="M10 82L5 77H10V82Z" fill="var(--btn-bg)" />
                                </g>
                                <defs>
                                    <filter id="filter0_d_653_3422" x="0" y="5" width="38" height="78" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                                        <feFlood flood-opacity="0" result="BackgroundImageFix" />
                                        <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                        <feOffset dx="-1" dy="2" />
                                        <feGaussianBlur stdDeviation="2" />
                                        <feComposite in2="hardAlpha" operator="out" />
                                        <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0" />
                                        <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_653_3422" />
                                        <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_653_3422" result="shape" />
                                    </filter>
                                    <filter id="filter1_d_653_3422" x="0" y="0" width="13" height="13" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                                        <feFlood flood-opacity="0" result="BackgroundImageFix" />
                                        <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                        <feOffset dx="-1" dy="2" />
                                        <feGaussianBlur stdDeviation="2" />
                                        <feComposite in2="hardAlpha" operator="out" />
                                        <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0" />
                                        <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_653_3422" />
                                        <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_653_3422" result="shape" />
                                    </filter>
                                    <filter id="filter2_d_653_3422" x="0" y="75" width="13" height="13" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                                        <feFlood flood-opacity="0" result="BackgroundImageFix" />
                                        <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                        <feOffset dx="-1" dy="2" />
                                        <feGaussianBlur stdDeviation="2" />
                                        <feComposite in2="hardAlpha" operator="out" />
                                        <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0" />
                                        <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_653_3422" />
                                        <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_653_3422" result="shape" />
                                    </filter>
                                </defs>
                            </svg>}
                {
                    pdfSideViwer.show && <>    
                        {
                            pdfSideViwer.url?.split('.').pop()?.toLowerCase() === "pdf" ?
                                <Document file={pdfSideViwer.url} onLoadSuccess={onDocumentLoadSuccess} loading={<Loading screenName="pdfView" />} >
                                    {Array.from(new Array(numPages), (el, index) => (
                                        <Page key={`page_${index + 1}`} pageNumber={index + 1} size="A1" scale={scale} />
                                    ))}
                                </Document>
                            :
                            pdfSideViwer.url?.includes("www.youtube.com/embed") ?
                                <iframe width="100%" height="100%" src={pdfSideViwer.url} title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
                            :
                                <iframe src={`https://view.officeapps.live.com/op/embed.aspx?src=${pdfSideViwer.url}`} width='100%' height='100%' frameborder='0'>This is an embedded <a target='_blank' href='http://office.com'>Microsoft Office</a> document, powered by <a target='_blank' href='http://office.com/webapps'>Office Online</a>.</iframe>      
                        }
                    </>
                }
            </div>
        </div>  
    )
}
export default PdfSideView